export const MGR_REQUEST = 'MGR_REQUEST'
export const MGR_REQUEST_ERROR = 'MGR_REQUEST_ERROR'
export const MGR_ORDERS_REQUEST = 'MGR_ORDERS_REQUEST'
export const MGR_ORDERS_STATUS_LIST_REQUEST = 'MGR_ORDERS_STATUS_LIST_REQUEST'
export const MGR_SET_ORDER = 'MGR_SET_ORDER'
export const MGR_PRICEHEADERS_REQUEST = 'MGR_PRICEHEADERS_REQUEST'
export const MGR_PRICE_LIST_REQUEST = 'MGR_PRICE_LIST_REQUEST'
export const MGR_SET_PRICE_ITEM = 'MGR_SET_PRICE_ITEM'
export const MGR_REQUEST_PRICE_STATES = 'MGR_REQUEST_PRICE_STATES'
